import {
  consumeVacation,
  consumedDaysTotal,
  type GermanStateCode,
  type LeaveDayPartCode,
  type LeaveWeekWeights,
} from '@gb-ticket/shared-types';

export function formatLeaveDays(value: number): string {
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value);
}

/** Days a vacation span would consume for the person's current week and holidays. */
export function previewVacationDays(input: {
  startsOn: string;
  endsOn: string;
  startPart: LeaveDayPartCode;
  endPart: LeaveDayPartCode;
  weights: LeaveWeekWeights & { stateCode: GermanStateCode };
  holidays: readonly string[];
  maxDaysPerRequest?: number | null;
}): number {
  const days = consumeVacation(
    {
      startsOn: input.startsOn,
      endsOn: input.endsOn,
      startPart: input.startPart,
      endPart: input.endPart,
      maxDaysPerRequest: input.maxDaysPerRequest,
    },
    [{ effectiveFrom: '2000-01-01', ...input.weights }],
    {
      company: [],
      byState: { [input.weights.stateCode]: [...input.holidays] },
    },
  );
  return consumedDaysTotal(days);
}
